import {showComment} from "./src/snowComment/snowComment";
import {AppUserInterface} from "./src/AppUserInterface/AppUserInterface";
import {PhpDataProvider} from "./src/PhpDataProvider/PhpDataProvider";
import {runSearch} from "./src/runSearch/runSearch";
import {SearchWhispererHtmlElement} from "./src/SearchWhisperer/SearchWhispererHtmlElement";

window.addEventListener('DOMContentLoaded', () => {

    // Pridame funkci showComment do globalu.
    const _global = (window /* browser */ || global /* node */) as any;
    _global.showComment = showComment;

    // Registrujeme custom SearchWhispererHtmlElement. Vytvorime jej. Provedeme potrebna nastaveni. A pripmene na body.
    customElements.define('search-whisperer', SearchWhispererHtmlElement);
    const searchWhisperer = document.createElement('search-whisperer') as SearchWhispererHtmlElement;
    searchWhisperer.setPositionUnderSearchBar();
    (document.querySelector('body') as HTMLBodyElement).prepend(searchWhisperer);

    const phpData             = new PhpDataProvider();
    const userInterface       = new AppUserInterface();

    // Naseptavac
    userInterface.searchBox.addEventListener('keyup', (event: KeyboardEvent) => {

        // Pokud je search field prazdny, neprovadime zadnou akci.
        if (userInterface.searchBox.value.length === 0) {
            return;
        }

        // Vyhledavani odstartovane stisknutim entru.
        if ([ 'Enter', 'NumpadEnter'].includes(event.code)) {
            searchWhisperer.hideSuggestions();
            runSearch(userInterface, phpData.server, phpData.regionId, phpData.locale, phpData.pageSeoString);
            return;
        }

        if (event.code === 'ArrowUp') {
            searchWhisperer.setPreviousItemAsActive();
            return;
        } else if (event.code === 'ArrowDown') {
            searchWhisperer.setNextItemAsActive();
            return;
        }

        searchWhisperer.showSuggestionsFor(userInterface.searchBox.value.trim());
        searchWhisperer.setPositionUnderSearchBar();
        searchWhisperer.removeActiveItem();
    });

    // Pokud se zmenil text ve vyhledavacim boxu a vyhledavaci boxu je prazdny, schovame naseptavac.
    userInterface.searchBox.addEventListener('input', (event) => {
        if ((event.target as HTMLInputElement).value.length === 0) {
            searchWhisperer.hideSuggestions();
        }
    });

    // Vyhledavani odstartovane kliknutim na ikonku lupy.
    userInterface.magnifyingGlassIcon.addEventListener('click', () => {
        if (userInterface.searchBox.value.length === 0) {
            return;
        }

        runSearch(userInterface, phpData.server, phpData.regionId, phpData.locale, phpData.pageSeoString);
    });

});
